import React, {useEffect} from 'react'
import Subtitle from "../../components/Subtitle";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";

const LiteratureLayout = ( ) =>{
    const {t} =useTranslation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/literature",
            type:"pageView"
        }))
    });
    return (
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('literature.title' as any)}
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('literature.subtitle' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    BlueGreenStreets (2020): BlueGreenStreets als multicodierte Strategie zur Klimafolgenanpassung –
                    Wissenstand 2020, Hamburg. Statusbericht im Rahmen der BMBF-Fördermaßnahme „Ressourceneffiziente
                    Stadtquartiere für die Zukunft“.

                    <br/> <br/> Ferrini, F., Konijnendijk van den Bosch, C. C., Fini, A. (2017): Routledge Handbook of Urban
                    Forestry. Routledge, London.

                    <br/> <br/> GALK e. V. (2018): GALK Straßenbaumliste. Deutsche Gartenamtsleiterkonferenz.

                    <br/> <br/> IPCC (2022): Climate Change 2022: Impacts, Adaptation and Vulnerability. Contribution of Working
                    Group II to the Sixth Assessment Report of the Intergovernmental Panel on Climate Change [H.-O.
                    Pörtner, D.C. Roberts, M. Tignor, E.S. Poloczanska, K. Mintenbeck, A. Alegría, M. Craig, S.
                    Langsdorf, S. Löschke, V. Möller, A. Okem, B. Rama (eds.)]. Cambridge University Press. Cambridge
                    University Press, Cambridge, UK and New York, NY, USA, 3056 pp., doi:10.1017/9781009325844.

                    <br/> <br/> Kuttler, W. (2004): Stadtklima.Teil 1: Grundzüge und Ursachen. Umweltwissenschaften und
                    Schadstoffforschung. Zeitschrift für Umweltchemie und Ökotoxikologie 16, 187–199.

                    <br/> <br/> Limmer, T. (2018): Stadtbäume in Würzburg: Wie die Öffentlichkeit durch Informationsvisualisierungen
                    sensibilisiert werden kann. HAW München, TU München, München.

                    <br/> <br/> McHale, M. R., Burke, I. C., Lefsky, M. A., Peper, P. J., McPherson, E. G. (2009): Urban
                    forest
                    biomass estimates: is it important to use allometric relationships developed specifically for urban
                    trees? Urban Ecosystems 12:95–113, doi: 10.1007/s11252-009-0081-3.

                    <br/> <br/> MEA, Millennium Ecosystem Assessment (2005): Millennium Ecosystem Assessment. Living
                    beyond Our
                    Means: Natural Assets and Human Well-Being, Washington D.C

                    <br/> <br/> Meyer, F. H. (1978): Bäume in der Stadt. Ulmer Verlag, Stuttgart

                    <br/> <br/> Niinemets, Ü., Valladares, F. (2006): Tolerance to shade, drought, and waterlogging of
                    temperate
                    northern hemisphere trees and shrubs. Ecological monographs, 76(4), 521-547, doi:
                    10.1890/0012-9615(2006)076[0521:TTSDAW]2.0.CO;2.

                    <br/> <br/> Moser, A., Rötzer, T., Pauleit, S., Pretzsch, H. (2015): Structure and ecosystem
                    services of
                    small-leaved lime (Tilia cordata Mill.) and black locust (Robinia pseudoacacia L.) in urban
                    environments. Urban Forestry & Urban Greening 14, 1110–1121, doi: 10.1016/j.ufug.2015.10.005.

                    <br/> <br/> Moser, A., Rötzer, T., Pauleit, S., Pretzsch, H. (2018): Stadtbäume: Wachstum,
                    Funktionen und
                    Leistungen – Risiken und Forschungsperspektiven. Allgemeine Forst- und Jagd-Zeitung 188 (5/6):
                    94-111. doi: 10.23765/afjz0002006.

                    <br/> <br/> Oke, T. (1982): The energetic basis of the urban heat island. Quarterly Journal of the
                    Royal
                    Meteorological Society 108, 1–24, doi: 10.1002/qj.49710845502.

                    <br/> <br/> Parsa, A. V., Salehi, E., Yavari, A. R., van Bodegom, P. M. (2019): Evaluating the
                    potential
                    contribution of urban ecosystem service to climate change mitigation. Urban Ecosystems 22, 989–1006,
                    doi: 10.1007/s11252-019-00870-w.

                    <br/> <br/> Pauleit, S., Duhme, F. (1999): Stadtstrukturtypen. Bestimmung der Umweltleistungen von
                    Stadtstrukturtypen für die Stadtplanung. Raumplanung 84, 33–44.

                    <br/> <br/> Peper, P. J., Alzate, C. P., McNeil, J. W., Hashemi, J. (2014): Allometric equations for
                    urban ash
                    trees (Fraxinus spp.) in Oakville, Southern Ontario, Canada. Urban Forestry & Urban Greening 13,
                    175-183. doi: 10.1016/j.ufug.2013.07.002.

                    <br/> <br/> Rahman, M. A., Hartmann, C., Moser-Reischl, A., von Strachwitz, M. F., Paeth, H.,
                    Pretzsch, H.
                    (2020): Tree cooling effects and human thermal comfort under contrasting species and sites.
                    Agricultural and Forest Meteorology 287: 107947, doi: 10.1016/j.agrformet.2020.107947.

                    <br/> <br/> Raum S., Collins C.M., Urquhart J., Potter C., Pauleit S., Egerer M. (2023): Tree insect
                    pests and
                    pathogens: a global systematic review of their impacts in urban areas. Urban Ecosystems 26 (2),
                    587-604, doi: 10.1007/s11252-022-01317-5.

                    <br/> <br/> Roloff, A. (2013): Bäume in der Stadt. Ulmer, Stuttgart.

                    <br/> <br/> Rötzer, T., Häberle, K. H., Kallenbach, C., Matyssek, R., Schütze, G., Pretzsch, H.
                    (2017): Tree
                    species and size drive water consumption of beech/spruce forests – a simulation study highlighting
                    growth under water limitation. Plant and Soil 418, 337–356, doi: 10.1007/s11104-017-3306-x.

                    <br/> <br/> Rötzer T., Moser-Reischl A., Rahman M.A., Grote R., Pauleit S., Pretzsch H. (2021):
                    Modelling Urban
                    Tree Growth and Ecosystem Services: Review and Perspectives. In: Progress in Botany. Springer,
                    Berlin, Heidelberg; 82: 405 – 464; doi: 10.1007/124_2020_46

                    <br/> <br/> Rötzer, T., Moser-Reischl, A., Rahman, M.A., Hartmann, C., Paeth, H., Pauleit, S.,
                    Pretzsch, H.
                    (2021): Urban tree growth and ecosystem services under extreme drought. Agricultural and Forest
                    Meteorology, 308, doi: 10.1016/j.agrformet.2021.108532.

                    <br/> <br/> Rötzer, T., Rahman, M.A., Moser-Reischl, A., Pauleit, S., Pretzsch, H. (2019): Process
                    based simulation of tree growth and ecosystem services of urban trees under present and future
                    climate conditions. Science of the Total Environment 676: 651–664, doi:
                    10.1016/j.scitotenv.2019.04.235.

                    <br/> <br/> Scherer, D., Antretter, F., Bender, S., Cortekar, J., Emeis, S., Fehrenbach, U., Gross,
                    G., Halbig, G., Hasse, J., Maronga, B., Raasch, S., Scherber, K. (2019): Urban Climate Under Change
                    [UC] 2 – A National Research Programme for Developing a Building-Resolving Atmospheric Model for
                    Entire City Regions. Meteorologische Zeitschrift 28, 95–104. doi: 10.1127/metz/2019/0913.

                    <br/> <br/> TEEB DE, Naturkapital Deutschland (2016): Ökosystemleistungen in der Stadt – Gesundheit
                    schützen und Lebensqualität erhöhen, in: Kowarik, I., Bartz, R., Brenck, M. (Hgg.). Technische
                    Universität Berlin, Helmholtz-Zentrum für Umweltforschung – UFZ, Berlin, Leipzig.

                    <br/> <br/> Watt, M. S., Kirschbaum, M.U.F. (2011): Moving beyond simple linear allometric
                    relationships between tree height and diameter. Ecological Modelling 222, 3910–3916. doi:
                    10.1016/j.ecolmodel.2011.10.011.

                    <br/> <br/> Weller, M. (2021): Tree inventory data of Central European cities – Studies on the
                    composition and structure of urban tree populations and derivation of ecosystem services. Master
                    thesis TU Munich, School of Life Sciences, 78 pp.

                    <br/> <br/> Wilhelm, L. (2019): Perspektiven mit neuen Baumarten im städtischen Bereich.
                    Präsentation beim Kellerseminar am 14.03.2019, München.
                </Typography>
                <Typography variant="h6">
                    {t('literature.subtitle2' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    Böll, S. (2018): Stadtbäume der Zukunft. Wichtige Ergebnisse aus dem Forschungsprojekt „Stadtgrün
                    2021“. Veitshöchheimer Berichte 184, S. 75-85.

                    <br/> <br/> Franceschi, E., Moser-Reischl, A., Rahman, M. A., Pauleit, S., Pretzsch, H., Rötzer, T.
                    (2022): Crown Shapes of Urban Trees-Their Dependences on Tree Species, Tree Age and Local
                    Environment, and Effects on Ecosystem Services. Forests 13: 748, doi: 10.3390/f13050748.

                    <br/> <br/> Franceschi, E., Moser-Reischl, A., Honold, M., Rahman, M. A., Pretzsch, H., Pauleit, S.
                    (2023): Urban environment, drought events and climate change strongly affect the growth of common
                    urban tree species in a temperate city. Urban Forestry & Urban Greening 88: 128083, doi:
                    10.1016/j.ufug.2023.128083.

                    <br/> <br/> Haase, D., Hellwig, R. (2022): Effects of heat and drought stress on the health status of six urban
                    street tree species in Leipzig, Germany. Trees, Forests and People 8, 100252, doi:
                    10.1016/j.tfp.2022.100252.

                    <br/> <br/> IPCC (2022): Climate Change 2022: Impacts, Adaptation and Vulnerability. Contribution of Working
                    Group II to the Sixth Assessment Report of the Intergovernmental Panel on Climate Change [H.-O.
                    Pörtner, D.C. Roberts, M. Tignor, E.S. Poloczanska, K. Mintenbeck, A. Alegría, M. Craig, S.
                    Langsdorf, S. Löschke, V. Möller, A. Okem, B. Rama (eds.)]. Cambridge University Press. Cambridge
                    University Press, Cambridge, UK and New York, NY, USA, 3056 pp., doi: 10.1017/9781009325844.

                    <br/> <br/> Korkou, M., Tarigan, A. K. M., Hanslin, H. M. (2023): The multifunctionality concept in urban green
                    infrastructure planning: A systematic literature review. Urban Forestry & Urban Greening 85, 127975,
                    doi: 10.1016/j.ufug.2023.127975.

                    <br/> <br/> Pauleit, S., Erlwein, S., Linke, S., Rahman, M., Zölch, T., Rötzer T. (2023): Grün-blaue
                    Infrastruktur für die Klimawandelanpassung der Stadt. Promet 106, 81-90, DOI:
                    10.5676/DWD_pub/promet_106_08.

                    <br/> <br/> Pauleit, S., Zölch, T., Erlwein, S., Reischl, A., Rahman, M., Pretzsch, H., Rötzer, T. (2022): Urban
                    green infrastructures for climate change adaptation: a multiscale approach. In. Costanzo V., Evola
                    G., Marletta L. (Eds.). Urban Heat Stress and Mitigation Solutions. An Engineering Perspectives.
                    Routledge, Oxon and New York, pp. 301-322.

                    <br/> <br/> Pauleit S., Gulsrud, N., Raum, S.,Taubenböck, H., Leichtle, T., Erlwein S., Rötzer T., Rahman M.
                    Moser-Reischl, A. (2022): Smart Urban Forestry: is it the future? In: Chokhachian, A., Hensel. M.U.,
                    Perini, K. (Eds.) Informed urban Environments. Springer Nature, Switzerland.

                    <br/> <br/> Rahman, M. A., Franceschi, E., Pattnaik, N., Moser-Reischl, A., Hartmann, C., Paeth, H., Pretzsch,
                    H., Rötzer, T., Pauleit, S. (2022): Spatial and temporal changes of outdoor thermal stress:
                    influence of urban land cover types. Scientific Reports 12: 671, doi: 10.1038/s41598-021-04669-8

                    <br/> <br/> Roloff, A., Pietzarka, U., Gillner, S. (2022): Baumartenverwendung im Klimawandel: KlimaArten-Matrix
                    20211 (KLAM 2.0) und Empfehlungen zu Baumgrößen, -pflanzungen und -umfeld. Jahrbuch der Baumpflege
                    2022: 204-223. Haymarket Media, Braunschweig

                    <br/> <br/> Rötzer, T., Reischl, A., Rahman, M., Pretzsch, H., Pauleit, S. (2021): Leitfaden zu Stadtbäumen in
                    Bayern. Handlungsempfehlungen aus dem Projekt Stadtbäume – Wachstum, Umweltleistungen und
                    Klimawandel. Zentrum Stadtnatur und Klimaanpassung, 72 Seiten.

                    <br/> <br/> UN (2022): World Cities Report 2022. Envisaging the Future of Cities. United Nations Human
                    Settlements Programme - Headquarters. ISBN 978-92-1-132894-3
                </Typography>

            </Box>
        </React.Fragment>
    )
}
export default LiteratureLayout
